import { Result } from "../types/result";

export function parseU64(s?: string | null): bigint | null {
    if (!s) return null;
    return BigInt(s);
}

/**
 * Like {@link parseU64}, but surfaces nullish input as {@link Result.err} instead of `null`.
 * Use `.unwrap()` when bad data should fail fast (e.g. market parser); use {@link parseU64OrZero} for permissive parsers.
 */
export function parseU64Required(s?: string | null): Result<bigint> {
    if (s === null || s === undefined || s === "") {
        return Result.err(`Expected U64String but got null/undefined. Value: ${String(s)}`);
    }
    try {
        return Result.ok(BigInt(s));
    } catch {
        return Result.err(`Invalid U64String: ${String(s)}`);
    }
}

/** Same as {@link parseU64Required} followed by `0n` when the value is invalid. */
export function parseU64OrZero(s?: string | null): bigint {
    const r = parseU64Required(s);
    return r.isOk() ? r.unwrap() : BigInt(0);
}

/**
 * Like {@link parseU64}, but for genuinely-optional fields where absence is meaningful:
 * nullish/empty input stays `undefined` (never coerced to `0n`). Use for fields that may
 * legitimately be missing (e.g. an optional `lpBalance`), not for UI-safe fallbacks.
 */
export function parseU64Optional(s?: string | null): bigint | undefined {
    return parseU64(s) ?? undefined;
}
